module.exports = __webpack_public_path__ + "static/media/13ITC1.f15d7f99.jpg";